import { useDispatch } from "react-redux";
import DynamicIcon from "../DynamicIcon";
import { setModal } from "../../redux/rightModalSlice";
import { deleteSupplier } from "../../redux/suppliers/suppliersSlice";
import { useState } from "react";

export default function SupplierLine({ supplierData, index, rowBgColor, rowTextColor, rowHoverBgColor, rowHoverTextColor, onDelete }) {
    const [isHovered, setIsHovered] = useState(false);
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const dispatch = useDispatch();
    const token = localStorage.getItem('installamelo-auth-token');

    // Gestisce il click sul bottone di modifica
    const handleEditClick = (e) => {
        e.stopPropagation();
        dispatch(setModal({
            mode: 'edit',
            id: supplierData._id
        }));
    };

    // Gestisce il click sul bottone di visualizzazione
    const handleViewClick = (e) => {
        e.stopPropagation();
        dispatch(setModal({
            mode: 'view',
            id: supplierData._id
        }));
    };

    // Gestisce il click sul bottone elimina
    const handleDeleteClick = (e) => {
        e.stopPropagation();
        setShowDeleteConfirm(true);
    };

    // Conferma eliminazione
    const confirmDelete = (e) => {
        e.stopPropagation();
        setDeleting(true);
        dispatch(deleteSupplier({
            supplierId: supplierData._id,
            token
        })).then((result) => {
            setDeleting(false);
            if (!result.error) {
                setShowDeleteConfirm(false);
                if (onDelete) onDelete();
            }
        });
    };

    // Gestisce il click sull'intera riga
    const handleRowClick = () => {
        if (showDeleteConfirm) return;
        dispatch(setModal({
            mode: 'view',
            id: supplierData._id
        }));
    };

    return (
        <>
            <div
                style={{
                    backgroundColor: isHovered ? rowHoverBgColor : rowBgColor,
                    color: isHovered ? rowHoverTextColor : rowTextColor,
                    transition: 'background-color 0.15s ease'
                }}
                className="w-full flex justify-between cursor-pointer rounded-lg border-b border-gray-100"
                onClick={handleRowClick}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                {/* Codice */}
                <div className="px-6 py-4 w-1/5">
                    <div className="font-semibold">{supplierData.code || "--"}</div>
                </div>

                {/* Azienda */}
                <div className="px-6 py-4 w-1/5 truncate">
                    {supplierData.company || "--"}
                </div>

                {/* P.IVA / C.F. */}
                <div className="px-6 py-4 w-1/5 truncate">
                    {supplierData.vatNumber || supplierData.fiscalCode || "--"}
                </div>

                {/* Città */}
                <div className="px-6 py-4 w-1/5 truncate">
                    {supplierData.city || "--"}
                </div>

                {/* Bottoni Azioni */}
                <div className="px-6 py-4 w-1/5 flex justify-end items-center space-x-2">
                    <button
                        className="p-1 hover:bg-blue-100 rounded-full"
                        onClick={handleViewClick}
                        title="Visualizza"
                    >
                        <DynamicIcon iconClass="fa-solid fa-eye" />
                    </button>
                    <button
                        className="p-1 hover:bg-blue-100 rounded-full"
                        onClick={handleEditClick}
                        title="Modifica"
                    >
                        <DynamicIcon iconClass="fa-solid fa-edit" />
                    </button>
                    <button
                        className="p-1 hover:bg-red-100 rounded-full text-red-500"
                        onClick={handleDeleteClick}
                        title="Elimina"
                    >
                        <DynamicIcon iconClass="fa-solid fa-trash" />
                    </button>
                </div>
            </div>

            {/* Dialog conferma eliminazione */}
            {showDeleteConfirm && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" onClick={(e) => e.stopPropagation()}>
                    <div className="bg-white rounded-lg p-6 max-w-md w-full">
                        <h3 className="text-xl font-bold mb-4">Conferma Eliminazione</h3>
                        <p className="mb-6">
                            Sei sicuro di voler eliminare il fornitore "<strong>{supplierData.company || supplierData.code}</strong>"?
                            Questa azione non può essere annullata.
                        </p>
                        <div className="flex justify-end space-x-3">
                            <button
                                className="secondary"
                                onClick={(e) => { e.stopPropagation(); setShowDeleteConfirm(false); }}
                                disabled={deleting}
                            >
                                Annulla
                            </button>
                            <button
                                className="danger"
                                onClick={confirmDelete}
                                disabled={deleting}
                            >
                                {deleting ? (
                                    <>
                                        <DynamicIcon iconClass="fas fa-spinner fa-spin" />
                                        Eliminazione...
                                    </>
                                ) : (
                                    <>
                                        <DynamicIcon iconClass="fas fa-trash" />
                                        Elimina
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
